import { useGetOwnSubscriptionQuery } from "@lib/store/slices/billing";
import { useGetOwnCompaniesQuery } from "@lib/store/slices/companies";
import { useGetOwnJobImportSourcesQuery } from "@lib/store/slices/jobImportSource";
import { useGetOwnJobsQuery } from "@lib/store/slices/jobs";

export default function useSubscriptionLimits() {
  const { data: subscription, isLoading } = useGetOwnSubscriptionQuery();
  const { data: companies, isLoading: isLoadingCompanies } =
    useGetOwnCompaniesQuery();
  const { data: jobs, isLoading: isLoadingJobs } = useGetOwnJobsQuery();
  const { data: importSources, isLoading: isLoadingImportSources } =
    useGetOwnJobImportSourcesQuery();

  const maxCompanies = subscription?.max_companies ?? 0;
  const maxJobs = subscription?.max_jobs ?? 0;
  const maxImportSources = subscription?.max_job_import_sources ?? 0;

  const companyCount = companies?.length ?? 0;
  const activeJobsCount = jobs?.filter((job) => job.is_active).length ?? 0;
  const activeImportSourcesCount =
    importSources?.filter((importSource) => importSource.is_active).length ?? 0;

  return {
    subscription,
    isFreePlan: maxJobs === 3,
    isLoading:
      isLoading ||
      isLoadingCompanies ||
      isLoadingJobs ||
      isLoadingImportSources,
    companies: {
      current: companyCount,
      max: maxCompanies,
      remaining: maxCompanies - companyCount,
    },
    jobs: {
      current: activeJobsCount,
      max: maxJobs,
      remaining: maxJobs - activeJobsCount,
    },
    importSources: {
      current: activeImportSourcesCount,
      max: maxImportSources,
      remaining: maxImportSources - activeImportSourcesCount,
    },
  };
}
